module.exports = __webpack_public_path__ + "static/img/exit-64px.9d38eada.png";